
export function generateUUID(): string {
  const result: string[] = [];
  for (let j = 0; j < 32; j++) {
    if(j === 8 || j === 12 || j === 16 || j === 20) {
      result.push('-');
    }
    const c = Math.floor(Math.random()*16).toString(16).toLowerCase();
    result.push(c);
  }
  return result.join('');
}
